import { router } from '@/router';
import { actionTypes, errorTypes, commandTypes, mutationTypes } from '@/types';
import { SEARCH_SCOPES, syncActionStates } from '@/tools/consts';
import { nativeMethodCall } from '@/tools/nativeInterface';
import { sendForm } from '@/tools/sendForm';
import logger from '@/tools/logger';
import setMediaObjectsSources from '@/tools/setMediaObjectsSources';

const pluginCommands = [];

export function registerPlugin(plugin) {
	pluginCommands.push(plugin);
}
/**
 * Parses ValueString to Boolean, Number, Object or String
 * @param {valueString} valueString
 */
function parseParameterValues(valueString) {
	try {
		return JSON.parse(valueString);
	} catch (e) {
		return valueString; // Its not parseable it has to be normal string
	}
}
function parseCommandTimer(command, parameters, dispatch) {
	if (parameters.time) {
		// TODO: //reimplement kill timers of article changes
		setTimeout(() => {
			dispatch(actionTypes.executeCommand, { command, parameters });
		}, parameters.time);
		if (!parameters.force) {
			// TODO Implemtn force timer, timer which get not killed by page switch
			// state.getCurrentState().timerStorage.push(timer);
		}
	} else {
		dispatch(actionTypes.executeCommand, { command, parameters });
	}
}

export default {
	actions: {
		[actionTypes.parseCommands]({ dispatch }, { rawString, callback, parseCommandTimer = false }) {
			const commands = rawString.split('//').pop().split('|');
			commands.forEach((commandString) => {
				var command = commandString.split('?');
				let parameterObject = {};
				if (command[1]) {
					parameterObject = command[1].split('&').reduce((acc, param) => {
						const keyValPair = param.split('=');
						acc[keyValPair[0]] = keyValPair[1] ? parseParameterValues(keyValPair[1]) : true;

						return acc;
					}, {});
				}
				if (parseCommandTimer) parseCommandTimer(command[0], parameterObject, dispatch);
				else callback(command[0], parameterObject);
			});
			return;
		},
		async [actionTypes.executeCommandString]({ dispatch }, commandString) {
			dispatch(actionTypes.parseCommands, {
				rawString: commandString,
				callback: (command, parameters) => {
					if (!parameters.onLoad) parseCommandTimer(command, parameters, dispatch);
				},
			});
		},
		async [actionTypes.executeCommand]({ rootState, dispatch, getters, commit }, { command, parameters }) {
			if (!parameters) return;
			switch (command) {
				// FIXME missing command or remove it
				case commandTypes.openSearch: {
					// `command://openSearch?scope=articles&id=[exhibitionID]`
					// `command://openSearch?scope=articles&id=[exhibitionID]&sortBy=name` only for scope `articles`, `exhibitions`
					// `command://openSearch?scope=exhibtions&id=[exhibitionID]&sortBy=name` only for scope `articles`, `exhibitions`
					// `command://openSearch?scope=articles&id=[exhibitionID]&sortBy=title`
					// scope must be of type: articles, glossary, calendar, areabeacons, locations, tour, tours
					switch (parameters.scope) {
						case SEARCH_SCOPES.articles: {
							dispatch(actionTypes.searchShowArticles, {
								exhibitionID: parameters.id,
								options: { sortBy: parameters.sortBy },
							});
							break;
						}
						case SEARCH_SCOPES.glossary: {
							dispatch(actionTypes.searchShowGlossary);
							break;
						}
						case SEARCH_SCOPES.calendar: {
							dispatch(actionTypes.searchShowCalendar, { options: { closeButton: false } });
							break;
						}
						case SEARCH_SCOPES.areabeacons: {
							dispatch(actionTypes.searchShowAreaBeacons, { options: parameters });
							break;
						}
						case SEARCH_SCOPES.locations: {
							dispatch(actionTypes.searchShowLocationsByList, {
								locationIDs: parameters.ids.split(','),
							});
							break;
						}
						case SEARCH_SCOPES.tour: {
							dispatch(actionTypes.searchShowTour, { tourID: parameters.id, options: parameters });
							break;
						}
						case SEARCH_SCOPES.tours: {
							dispatch(actionTypes.searchShowTours, { options: parameters });
							break;
						}
						default: {
							logger.error(`Unknown command: "${command}" with scope: ${JSON.stringify(parameters.scope)}`);
							dispatch(actionTypes.sendErrorMessage, { error: new Error(errorTypes.unknownCommand) });
						}
					}
					break;
				}
				// `command://startSubModule?id=bluetooth`
				case commandTypes.startSubModule: {
					dispatch('startSubModule', { subModuleName: parameters.id });
					break;
				}
				// `command://stopSubModule?id=bluetooth`
				case commandTypes.stopSubModule: {
					dispatch('stopSubModule', { subModuleName: parameters.id });
					break;
				}
				case commandTypes.sendForm: {
					sendForm({ state: rootState, dispatch });
					break;
				}
				case commandTypes.varIncrement:
					break;
				case commandTypes.varDecrement:
					break;
				case commandTypes.varSet:
					break;
				case commandTypes.varToggle:
					break;
				case commandTypes.allowUserInput:
					break;

				// `command://showInModal?exhibitionID=[exhibitionID]&articleID=[articleID]`
				case commandTypes.openInModal:
				case commandTypes.showInModal:
					dispatch(actionTypes.contentModalSet, {
						articleID: parameters.articleID,
						exhibitionID: parameters.exhibitionID,
					});
					break;
				// `command://openModal?id=['ui--map','system--beacons','system--beacon-list','system--info','system--security','ui--keypad','ui--language']`
				case commandTypes.openModal:
				case commandTypes.showModal: {
					dispatch(actionTypes.openModal, { id: parameters.id });
					break;
				}
				// `command://closeModal?id=['ui--map','system--beacons','system--beacon-list','system--info','system--security','ui--keypad','ui--language']`
				case commandTypes.closeModal:
				case commandTypes.hideModal: {
					dispatch(actionTypes.closeModal, { id: parameters.id });
					break;
				}
				// `command://toggleModal?id=['ui--map','system--beacons','system--beacon-list','system--info','system--security','ui--keypad','ui--language']`
				case commandTypes.toggleModal: {
					dispatch(actionTypes.toggleModal, { id: parameters.id });
					break;
				}
				// `command://setLanguage?lang=[e.g. 'de','en,'des']`
				case commandTypes.setLang:
				case commandTypes.setLanguage:
					{
						dispatch('setLanguage', { language: parameters.lang || parameters.language });
					}
					break;
				// `command://setExhibitionLanding`
				case commandTypes.setExhibitionLanding: {
					dispatch(actionTypes.pushUrl, {
						url: `/${rootState.currentExhibitionID}/${getters.currentExhibition.landingArticleID}`,
					});
					break;
				}
				// `command://setArticle?id=[articleID]]`
				case commandTypes.setArticle: {
					const options = {
						exhibitionID: rootState.currentExhibitionID,
						articleID: parameters.id,
						code: parameters.code,
						language: parameters.lang,
						retainModal: parameters.retain,
						endTour: parameters.endTour,
					};
					dispatch(actionTypes.setExhibition, options);
					break;
				}
				// `command://addClass?target=[cssSelector]&class='string'`
				case commandTypes.addClass:
					[...document.querySelectorAll(parameters.target)].forEach(function (element) {
						element.classList.add(parameters.class);
					});
					break;
				// `command://removeClass?target=[cssSelector]&class='string'`
				case commandTypes.removeClass:
					[...document.querySelectorAll(parameters.target)].forEach(function (element) {
						element.classList.remove(parameters.class);
					});
					break;
				// `command://toggleClass?target=[cssSelector]&class='string'`
				case commandTypes.toggleClass:
					[...document.querySelectorAll(parameters.target)].forEach(function (element) {
						element.classList.toggle(parameters.class);
					});
					break;
				// `command://setExhibition?id=[exhibitionID]`
				// `command://setExhibition?id=[exhibitionID]&articleid=[articleID]`
				// `command://setExhibition?id=[exhibitionID]&articleid=[articleID]&language=[language code]`
				// `command://setExhibition?id=[exhibitionID]&articleid=[articleID]&retainModal`
				// `command://setExhibition?id=[exhibitionID]&code=[code of an article]`
				// `command://setExhibition?id=[exhibitionID]&endTour=true`
				case commandTypes.setExhibition:
					{
						const options = {
							exhibitionID: parameters.id,
							articleID: parameters.articleid,
							code: parameters.code,
							language: parameters.lang,
							retainModal: parameters.retain,
							endTour: parameters.endTour,
						};
						dispatch(actionTypes.setExhibition, options);
					}
					break;
				// `command://startTour?id=[tourID]`
				// `command://startTour?id=[tourID]&articleid=[articleID]`
				// `command://startTour?id=[tourID]&noOfflineSync=[true]`
				case commandTypes.startTour:
					{
						const options = {
							tourID: parameters.id,
							articleID: parameters.articleid,
							noOfflineSync: parameters.noOfflineSync,
						};
						dispatch(actionTypes.tourStart, options);
					}
					break;
				case commandTypes.loadExhibition: {
					const { id } = parameters;
					if (
						rootState.packageSyncer.subPartStates[id] === syncActionStates.loaded ||
						rootState.packageSyncer.subPartStates.all === syncActionStates.loaded
					) {
						dispatch(actionTypes.setExhibition, { exhibitionID: id });
					} else {
						dispatch(actionTypes.sendErrorMessage, {
							error: new Error(errorTypes.packageSyncerExhibitionNotDownloaded),
						});
					}
					break;
				}
				// `command://startTutorial?id=[tourID]`
				case commandTypes.startTutorial:
					{
						const options = {
							tourID: parameters.id,
						};
						dispatch(actionTypes.tutorialStart, options);
					}
					break;
				// `command://setExhibitionList`
				case commandTypes.setExhibitionList:
					logger.error('setExhibitionList is not implemented');
					// setExhibitionList(); // FIXME this is not defined
					break;
				// `command://sendToCommand?topic=mobile&message={"dispatch":[{"action":"setExhibition","payload":{"articleID":"5db84c556b38790c05744724","exhibitionID":"5daefc0c22e3551514c825a3"}},{"action":"videoLoadAndPlay","payload":{"mediaID":"5db2f0b222e3551514c857c3"}}]}`
				// {
				// 	dispatch: [
				// 		{
				// 			action: 'setExhibition',
				// 			payload: {
				// 				articleID: '5dcd6d2d1607e90a750d1e8d',
				// 				exhibitionID: '5daefc0c22e3551514c825a3',
				// 			},
				// 		},
				// 		{
				// 			action: 'videoLoadAndPlay',
				// 			payload: {
				// 				mediaID: '5db2f19922e3551514c85c0b',
				// 			},
				// 		},
				// 	],
				// }
				case commandTypes.sendToCommand: {
					const { mobile: mqttMobileSettings, mediaPlayers: mqttMediaPlayerSettings } =
						rootState.dataSourceCFG.global.MQTTSupport;
					if (mqttMobileSettings.active || mqttMediaPlayerSettings.active) {
						dispatch(actionTypes.mqttPublish, { topic: parameters.topic, message: parameters.message });
					} else {
						dispatch(actionTypes.sendErrorMessage, { error: new Error(errorTypes.mqttNotAvailable) });
					}
					break;
				}
				case commandTypes.resetSessionStorage:
					// variableStoragevariableStorage.resetSessionStorage(); // FIXME how can this work if variableStorage is not defined
					break;
				// `command://doMethodCall?jscall=[window method name]&...`
				case commandTypes.doMethodCall:
					window[parameters.jscall](parameters);
					break;
				case commandTypes.setConfig:
					break;
				// `command://back`
				case commandTypes.back: {
					router.back();
					break;
				}
				case commandTypes.setFocus: {
					break;
				}
				// `command://geoLocationStart`
				case commandTypes.geoLocationStart: {
					dispatch(actionTypes.geoLocationStart);
					break;
				}
				case commandTypes.sharePage: {
					break;
				}
				// `command://contentOpen?url=http://www.example.com`
				case commandTypes.contentOpen: {
					const url = decodeURIComponent(parameters.url);
					if (rootState.isApp) nativeMethodCall({ method: 'nativeContentOpen', params: [url] });
					else window.open(`https://${url}`, '_blank');
					break;
				}
				// `command://noOp`
				case commandTypes.noOp:
					break;
				// `command://setFontSize?size=['smaller','medium','larger','largest']`
				case commandTypes.setFontSize: {
					dispatch('setFontSize', { size: parameters.size });
					break;
				}

				case commandTypes.scrollToTop: {
					dispatch('scrollToTop');
					break;
				}
				case commandTypes.setColorMode: {
					dispatch('setColorMode', { colorMode: parameters.colorMode });
					break;
				}
				case commandTypes.mqttSubscribeTopic: {
					dispatch('mqttSubscribe', { topic: parameters.topic });
					break;
				}
				case commandTypes.toggleAudioAutoPlay: {
					dispatch('audioAutoPlay', { autoPlay: parameters.audioAutoPlay });
					break;
				}
				case commandTypes.triggerContentOnGeolocationChange: {
					commit(mutationTypes.triggerContentOnGeolocationChange, {
						trigerredContent: parameters.triggerContentOnGeolocationChange,
					});
					dispatch('triggerGeoLocation', { currentCoordinate: rootState.geoLocation.currentCoordinate });
					break;
				}
				case commandTypes.offTriggeringContentOnGeolocationChange: {
					dispatch('offTriggeringGeoLocation', {
						trigerredContent: false,
					});
					break;
				}
				case commandTypes.videoLoadAndPlay: {
					const mediaObjects = rootState.dataSourceCFG.mediaObjectsInfo.mediaObjectsForWebStations;
					commit(actionTypes.addToMediaObjectMap, {
						mediaObjectArray: setMediaObjectsSources(mediaObjects, rootState.dataSourceURL),
					});
					dispatch('videoLoadAndPlay', {
						mediaID: parameters.mediaID,
					});
					break;
				}
				default:
					for (const pluginCommand of pluginCommands) {
						if (pluginCommand(command, parameters)) {
							return;
						}
					}
					logger.warn(`Unknown command: "${command}" with parameters: ${JSON.stringify(parameters)}`);
					dispatch(actionTypes.sendErrorMessage, { error: new Error(errorTypes.unknownCommand) });
					break;
			}
		},
	},
};

// export { doCommand, parseCommands, parseCommandTimer, executeCommandString };
